<template>
    <div
        class="tag"
        :class="data.className"
    >
        {{data.title}}
    </div>
</template>

<script>
export default {
    name : "BooleanDisplay",
    props : {
        value : {
            type : Boolean,
            required : true,
        },
    },
    computed : {
        data () {
            return {
                className : this.value ? 'is-link' : 'is-light',
                title : this.value ? 'Yes' : 'No',
            };
        }
    },
}
</script>

<style scoped>

</style>
